import MinimizableModals from './minimizableModals';

export default MinimizableModals;
